import { Layer as LayerType } from './queries';

export const getCentroidFromPolygon = (polygon: any) => {
  const coordinates = polygon.coordinates[0];
  let sumX = 0;
  let sumY = 0;
  const len = coordinates.length;

  coordinates.forEach((coord: any) => {
    sumX += coord[0];
    sumY += coord[1];
  });

  return [sumX / len, sumY / len];
};

export const getTransformedData = (data: LayerType | undefined) => {
  return data?.features
    ?.filter((feature) => feature.geometry && feature.geometry.coordinates.length)
    ?.map((feature) => {
      if (feature.geometry.type === 'MultiPoint') {
        return {
          ...feature,
          geometry: {
            type: 'Point',
            coordinates: feature.geometry.coordinates[0],
          },
        };
      }

      if (feature.geometry.type === 'MultiPolygon' || feature.geometry.type === 'Polygon') {
        const centroid = getCentroidFromPolygon(feature.geometry);
        return {
          ...feature,
          geometry: {
            type: 'Point',
            coordinates: centroid,
          },
        };
      }
      return feature;
    });
};

export const handleClusterClick = (
  e: mapboxgl.MapMouseEvent,
  map: mapboxgl.Map,
  clusterType: 'farmers' | 'forests',
) => {
  const clusterLayer = `${clusterType}-clusters`;
  if (!map.getLayer(clusterLayer)) return;

  const features = map.queryRenderedFeatures(e.point, { layers: [clusterLayer] });
  if (!features?.length) return;

  const clickedFeature = features[0];
  const clusterId = clickedFeature.properties?.cluster_id;
  // 2026-09-17: was `${clusterType}s` → 'farmerss'/'forestss', sources that do
  // not exist, so a cluster click silently did nothing. The source ids are
  // 'farmers' and 'forests' (Layers.tsx).
  const source = map.getSource(clusterType) as mapboxgl.GeoJSONSource | undefined;

  if (!source || clusterId == null) return;

  source.getClusterExpansionZoom(clusterId, (err, zoom) => {
    if (err || zoom == null) return;
    const coords = (clickedFeature.geometry as GeoJSON.Point).coordinates as [number, number];
    // 2026-09-17 (founder brief): zoom to the cluster's expansion zoom exactly -
    // the lowest zoom at which it splits. Previously `zoom + 1`.
    map.easeTo({ center: coords, zoom, duration: 500 });
  });
};
